<script setup lang="ts">
// The folder background in which the user clicked
defineProps({
  folder: null
})
const { createNewFolderInCollection } = useCollectionView()
const { uploadHere } = useContextMenu()
const { contextMenuCollectionViewBackgroundTestId: dataTestid } = useTestId()
</script>

<template>
  <div :data-testid>
    <menu-section>
      <dropdown-item
        shortcut="⌘D"
        @click="createNewFolderInCollection(folder)"
      >
        New Folder
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item
        shortcut="⌘O"
        @click="uploadHere(folder)"
      >
        Upload files...
      </dropdown-item>
      <dropdown-item
        shortcut="⌘L"
      >
        <template #default>
          Upload link...
        </template>
        <template #submenu>
          <context-menu-sub-upload-link />
        </template>
      </dropdown-item>
    </menu-section>
  </div>
</template>
